/******************************************************************************
 *** MbrasWhdwlHistory ** 탈퇴 상세내용
 *******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Util from "@/js/common/Util";
import React from "react";

import AtrzLineBox from "../../bgtovrl/dialog/AtrzLineBox";
import MemberFileView from "../../mbras/FileBox/MemberFileView";

interface Props {
    mbrasId        : string;
    mbrasAtrzDocId : string;
    showAtrzLine?  : boolean;
}

const MbrasWhdwlHistory = ({ mbrasId, mbrasAtrzDocId, showAtrzLine = true }: Props) => {
    const [openLine, setOpenLine] = React.useState(false);

    const [mbrasNm        , setMbrasNm        ] = React.useState(""); // 성명
    const [brdtDate       , setBrdtDate       ] = React.useState(""); // 생년월일
    const [gndrCd         , setGndrCd         ] = React.useState(""); // 성별
    const [telno          , setTelno          ] = React.useState(""); // 휴대전화번호
    const [lbrShpSeCd     , setLbrShpSeCd     ] = React.useState(""); // 근로형태
    const [ocptTypeCd     , setOcptTypeCd     ] = React.useState(""); // 직종
    const [ogdpOrgCd      , setOgdpOrgCd      ] = React.useState(""); // 소속 지부
    const [wtjrNm         , setWtjrNm         ] = React.useState(""); // 관내
    const [mbrasAtrzSeCd  , setMbrasAtrzSeCd  ] = React.useState(""); // 문서구분
    const [addr           , setAddr           ] = React.useState(""); // 주소
    const [memo           , setMemo           ] = React.useState(""); // 메모
    const [whdwlRsnCn     , setWhdwlRsnCn     ] = React.useState(""); // 탈퇴사유
    const [frstJncmpYmd   , setFrstJncmpYmd   ] = React.useState(""); // 입직년월일
    const [aplyYmd        , setAplyYmd        ] = React.useState(""); // 탈퇴 신청일자
    const [joinAtchFileId , setJoinAtchFileId ] = React.useState(""); // 탈퇴신청서 첨부파일 ID
    const [joinFileNm     , setJoinFileNm     ] = React.useState(""); // 탈퇴신청서 파일명
    const [wthdAtchFileId , setWthdAtchFileId ] = React.useState(""); // 원천징수 첨부파일 ID
    const [wthdFileNm     , setWthdFileNm     ] = React.useState(""); // 원천징수 첨부파일명
    const [etcAtchFileId  , setEtcAtchFileId  ] = React.useState(""); // 기타 첨부파일 ID
    const [etcFileNm      , setEtcFileNm      ] = React.useState(""); // 기타 첨부파일명
    const [listLine       , setListLine       ] = React.useState<any[]>([]); // 결재라인

    // 탈퇴 결재 문서 상세정보
    React.useEffect(() => {
        if (Util.isEmpty(mbrasAtrzDocId)) return;

        AppContext.showSpinner();

        Axios.dataAccess({
            url       : "system/mbras/chg/select-mbras-atrz-chg-detail.do",
            methodType: "post",
            paramType : "json",
            paramData : {
                mbrasAtrzDocId: mbrasAtrzDocId,
            },
            onSuccessFn: (res: any) => {
                const item     = res.result.mbrasDoc;
                const listFile = Array.isArray(res.result.listFile) ? res.result.listFile : [];
                const atrzLine = Array.isArray(res.result.listLine) ? res.result.listLine : [];

                const joinFileInfo = listFile.find((file: any) => String(file.mbrasFileSeCd) === "01"); // 탈퇴신청서
                const wthdFileInfo = listFile.find((file: any) => String(file.mbrasFileSeCd) === "02"); // 원천징수 동의서
                const etcFileInfo  = listFile.find((file: any) => String(file.mbrasFileSeCd) === "03"); // 기타 첨부파일

                setMbrasNm(item.mbrasNm);
                setBrdtDate(item.brdtDate);
                setGndrCd(item.gndrCd);
                setTelno(item.telno);
                setLbrShpSeCd(item.lbrShpSeCd);
                setOcptTypeCd(item.ocptTypeCd);
                setOgdpOrgCd(item.ogdpOrgCd);
                setWtjrNm(item.wtjrNm);
                setMbrasAtrzSeCd(item.mbrasAtrzSeCd);
                setAddr(item.addr);
                if (Util.isNotEmpty(item.memo)) setMemo(item.memo);
                if (Util.isNotEmpty(item.whdwlRsnCn)) setWhdwlRsnCn(item.whdwlRsnCn);
                setFrstJncmpYmd(item.frstJncmpYmd);setAplyYmd(item.whdwlDt);

                if (Util.isNotEmpty(joinFileInfo)) {
                    setJoinAtchFileId(joinFileInfo.mbrasAtchFileId);
                    setJoinFileNm(joinFileInfo.fileNm);
                }

                if (Util.isNotEmpty(wthdFileInfo)) {
                    setWthdAtchFileId(wthdFileInfo.mbrasAtchFileId);
                    setWthdFileNm(wthdFileInfo.fileNm);
                }

                if (Util.isNotEmpty(etcFileInfo)) {
                    setEtcAtchFileId(etcFileInfo.mbrasAtchFileId);
                    setEtcFileNm(etcFileInfo.fileNm);
                }

                setListLine(atrzLine);

                AppContext.hideSpinner();
            },
        });
    }, [mbrasAtrzDocId, mbrasId]);

    const renderValue = (value: string) => {
        return Util.isEmpty(value) ? "-" : value;
    };

    return (
        <div className="w100p bsBdb p2 pb8">
            {/* 결재라인 */}
            {showAtrzLine && (
                <AtrzLineBox
                    listLine={listLine}
                    open={openLine}
                    onToggle={() => setOpenLine((value) => !value)}
                    showOrgInfo={true}
                />
            )}

            {/* 탈퇴 정보 */}
            <div className="mt18">
                <div className="dpFlx aiC gap8 mb10 fm-b fs15 fc111827 ls06">
                    <span className="w4 h16 bdrd2 bgc007bff" />
                    탈퇴 정보
                </div>

                <div
                    className="bd1 bdcDDDDDD bdrd10 ofH bgcWhite"
                    style={{ boxShadow: "0 5px 16px rgba(31, 41, 55, 0.04)" }}
                >
                    {/* 1행 */}
                    <div className="dpFlx bdb1 bdcDDDDDD">
                        <div className="dpFlx flx1">
                            <div className="w120 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                성명
                            </div>
                            <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                {renderValue(mbrasNm)}
                            </div>
                        </div>

                        <div className="dpFlx flx1 bdl1 bdcDDDDDD">
                            <div className="w120 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                휴대전화번호
                            </div>
                            <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                {renderValue(Util.setPhoneNum(telno))}
                            </div>
                        </div>
                    </div>

                    {/* 2행 */}
                    <div className="dpFlx bdb1 bdcDDDDDD">
                        <div className="dpFlx flx1">
                            <div className="w120 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                생년월일
                            </div>
                            <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                {renderValue(Util.cvtDateStrForm(brdtDate, "-", "YYYYMMDD"))}
                            </div>
                        </div>

                        <div className="dpFlx flx1 bdl1 bdcDDDDDD">
                            <div className="w120 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                성별
                            </div>
                            <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                {renderValue(Util.getValToCode("GNDR_CD", gndrCd))}
                            </div>
                        </div>
                    </div>

                    {/* 3행 */}
                    <div className="dpFlx bdb1 bdcDDDDDD">
                        <div className="dpFlx flx1">
                            <div className="w120 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                소속본부
                            </div>
                            <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                {renderValue(Util.getUpOrgName(ogdpOrgCd.split("_")[0]))}
                            </div>
                        </div>

                        <div className="dpFlx flx1 bdl1 bdcDDDDDD">
                            <div className="w120 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                근로형태
                            </div>
                            <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                {renderValue(Util.getValToCode("LBR_SHP_SE_CD", lbrShpSeCd))}
                            </div>
                        </div>
                    </div>

                    {/* 4행 */}
                    <div className="dpFlx bdb1 bdcDDDDDD">
                        <div className="dpFlx flx1">
                            <div className="w120 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                소속지부
                            </div>
                            <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                {renderValue(Util.getDownOrgName(ogdpOrgCd))}
                            </div>
                        </div>

                        <div className="dpFlx flx1 bdl1 bdcDDDDDD">
                            <div className="w120 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                직종
                            </div>
                            <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                {renderValue(
                                    Util.getValToCode(
                                        lbrShpSeCd === "01" ? "PMEMP_OCPT_TYPE_CD" : "IREMP_OCPT_TYPE_CD",
                                        ocptTypeCd,
                                    ),
                                )}
                            </div>
                        </div>
                    </div>

                    {/* 5행 */}
                    <div className="dpFlx bdb1 bdcDDDDDD">
                        <div className="dpFlx flx1">
                            <div className="w120 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                관내
                            </div>
                            <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                {renderValue(wtjrNm)}
                            </div>
                        </div>

                        <div className="dpFlx flx1 bdl1 bdcDDDDDD">
                            <div className="w120 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                입직년월일
                            </div>
                            <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                {renderValue(Util.cvtDateStrForm(frstJncmpYmd, "-", "YYYYMMDD"))}
                            </div>
                        </div>
                    </div>

                    {/* 6행 */}
                    <div className="dpFlx bdb1 bdcDDDDDD">
                        <div className="dpFlx flx1">
                            <div className="w120 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                탈퇴신청일자
                            </div>
                            <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                {renderValue(Util.cvtDateStrForm(aplyYmd, "-", "YYYYMMDD"))}
                            </div>
                        </div>

                        <div className="dpFlx flx1 bdl1 bdcDDDDDD">
                            <div className="w120 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                문서구분
                            </div>
                            <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                {renderValue(Util.getValToCode("MBRAS_ATRZ_SE_CD", mbrasAtrzSeCd))}
                            </div>
                        </div>
                    </div>

                    {/* 주소 */}
                    <div className="dpFlx bdb1 bdcDDDDDD">
                        <div className="w120 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                            주소
                        </div>
                        <div className="flx1 dpFlx aiC bsBdb pl18 pr18 pt12 pb12 bgcWhite fm-c fs14 fc222222 ls06 lh20">
                            {renderValue(addr)}
                        </div>
                    </div>

                    {/* 메모 */}
                    <div className="dpFlx bdb1 bdcDDDDDD">
                        <div className="w120 minH64 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                            메모
                        </div>
                        <div
                            className="flx1 minH64 dpFlx aiC bsBdb pl18 pr18 pt12 pb12 bgcWhite fm-c fs14 fc222222 ls06 lh20"
                            style={{ whiteSpace: "pre-wrap" }}
                        >
                            {renderValue(memo)}
                        </div>
                    </div>

                    {/* 탈퇴사유 */}
                    <div className="dpFlx">
                        <div className="w120 minH64 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                            탈퇴사유
                        </div>
                        <div
                            className="flx1 minH64 dpFlx aiC bsBdb pl18 pr18 pt12 pb12 bgcWhite fm-c fs14 fc222222 ls06 lh20"
                            style={{ whiteSpace: "pre-wrap" }}
                        >
                            {renderValue(whdwlRsnCn)}
                        </div>
                    </div>
                </div>
            </div>

            {/* 첨부파일 */}
            <div className="mt18">
                <div className="dpFlx aiC gap8 mb10 fm-b fs15 fc111827 ls06">
                    <span className="w4 h16 bdrd2 bgc007bff" />
                    첨부파일
                </div>

                <div className="bd1 bdcDDDDDD bdrd10 ofH bgcWhite">
                    <div className="dpFlx h42 bdb1 bdcDDDDDD">
                        <div className="w150 h42 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                            탈퇴 신청서
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15">
                            <MemberFileView
                                mbrasId={mbrasId}
                                mbrasAtchFileId={joinAtchFileId}
                                mbrFileNm={joinFileNm}
                            />
                        </div>
                    </div>

                    <div className="dpFlx h42 bdb1 bdcDDDDDD">
                        <div className="w150 h42 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                            원천징수 동의서
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15">
                            <MemberFileView
                                mbrasId={mbrasId}
                                mbrasAtchFileId={wthdAtchFileId}
                                mbrFileNm={wthdFileNm}
                            />
                        </div>
                    </div>

                    <div className="dpFlx h42">
                        <div className="w150 h42 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                            기타
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15">
                            <MemberFileView
                                mbrasId={mbrasId}
                                mbrasAtchFileId={etcAtchFileId}
                                mbrFileNm={etcFileNm}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MbrasWhdwlHistory;